//import jaLocale from 'element-ui/lib/locale/lang/ja'
import store from "../../../store";

module.exports = {
    el: {
        colorpicker: {
            confirm: 'OK',
            clear: 'クリア'
        },
        datepicker: {
            now: '現在',
            today: '今日',
            cancel: 'キャンセル',
            clear: 'クリア',
            confirm: 'OK',
            selectDate: '日付を選択',
            selectTime: '時間を選択',
            startDate: '開始日',
            startTime: '開始時間',
            endDate: '終了日',
            endTime: '終了時間',
            prevYear: '前年',
            nextYear: '翌年',
            prevMonth: '前月',
            nextMonth: '翌月',
            year: '年',
            month1: '1月',
            month2: '2月',
            month3: '3月',
            month4: '4月',
            month5: '5月',
            month6: '6月',
            month7: '7月',
            month8: '8月',
            month9: '9月',
            month10: '10月',
            month11: '11月',
            month12: '12月',
            // week: '週次',
            weeks: {
                sun: '日',
                mon: '月',
                tue: '火',
                wed: '水',
                thu: '木',
                fri: '金',
                sat: '土'
            },
            months: {
                jan: '1月',
                feb: '2月',
                mar: '3月',
                apr: '4月',
                may: '5月',
                jun: '6月',
                jul: '7月',
                aug: '8月',
                sep: '9月',
                oct: '10月',
                nov: '11月',
                dec: '12月'
            }
        },
        select: {
            loading: 'ロード中',
            noMatch: 'データなし',
            noData: 'データなし',
            placeholder: '選択してください'
        },
        cascader: {
            noMatch: 'データなし',
            loading: 'ロード中',
            placeholder: '選択してください',
            noData: 'データなし'
        },
        pagination: {
            goto: '',
            pagesize: '件/ページ',
            total: '総計 {total} 件',
            pageClassifier: 'ページ目へ'
        },
        messagebox: {
            title: 'メッセージ',
            confirm: 'OK',
            cancel: 'キャンセル',
            error: '正しくない入力'
        },
        upload: {
            deleteTip: 'Delキーを押して削除する',
            delete: '削除する',
            preview: 'プレビュー',
            continue: '続行する'
        },
        table: {
            emptyText: 'データなし',
            confirmFilter: '確認',
            resetFilter: '初期化',
            clearFilter: 'すべて',
            sumText: '合計'
        },
        tree: {
            emptyText: 'データなし'
        },
        transfer: {
            noMatch: 'データなし',
            noData: 'データなし',
            titles: ['リスト 1', 'リスト 2'],
            filterPlaceholder: 'キーワードを入力',
            noCheckedFormat: '総計 {total} 件',
            hasCheckedFormat: '{checked}/{total} を選択した'
        },
        image: {
            error: 'FAILED' // to be translated
        },
        pageHeader: {
            title: 'Back' // to be translated
        }
    },
    netError: "ネットワーク接続エラーが発生しました。しばらくしてから再試行してください",
    cancel:"終了",
    confirm:"確認",
    delete:"削除",
    save:"保存",
    rename:"名称変更",
    userSpace: "個人ストレージ",
    entSpace: "企業ストレージ",
    allUser: "すべてのユーザー",
    frozen: "凍結済み",
    upload: "アップロード",
    import: "インポート",
    tips: "ヒント",
    prompt: "ヒント",
    success: "成功",
    return: "戻る",
    edit:"編集",
    close: "閉じる",
    noSearch: "検索結果がありません",
    loadmore: "さらに読み込む",
    retry: "再試行",
    allDelete: "すべて削除する",
    nextStep:"次へ",
    nodata:'関連の検索結果がありませんでした',
    back: "前へ",
    // message:{
    //     addSuccess:'追加しました',
    //     deleteSuccess:'削除しました',
    //     dismissSuccess:'解散しました',
    // },
    // valid: { //校验
    //     noSpace: "ストレージ容量を空にしないでください",
    //     intSpace: "ストレージ容量は正の整数を入力してください",
    //     moreSpace: "企業ストレージの総容量以内にしてください",
    //     moreData: "データセンターの容量以内にしてください",
    //     noPwd: "パスワードを空にしないでください",
    //     limitWord: "長さは6~32文字です",
    //     manyWord: "6~32の文字は、アルファベット、数字、特殊文字の2種を入れてください",
    //     phone: "正しい携帯番号を入力してください",
    //     noMail: "ログイン用のメールアドレスを入力してください",
    //     errorMail: "正しいメールアドレスを入力してください",
    //     noName: "名称を入力してください",
    // },
    // log: {
    //     userSpace: "個人ストレージ",
    //     entSpace: "企業ストレージ",
    //     time: "時間",
    //     actionName: "操作",
    //     netError: "ネットワーク接続エラーが発生しました。しばらくしてから再試行してください",
    //     title: "ログ検索",
    //     datearea: "時間",
    //     dateareaTip: "検索の効率を保証するために、毎回検索できるログは、31日間のものに限ります。",
    //     dateTo: "―",
    //     dateStart: "、開始日",
    //     dateEnd: "終了日",
    //     logExport: "ログをエクスポートする",
    //     category: "操作タイプ",
    //     allCategory: "全部",
    //     action: "操作",
    //     allAction: "すべてのアクティビティ",
    //     space: "空間",
    //     allSpace: "すべてのストレージ",
    //     pathValue: "キーワード",
    //     pathValuePH: "キーワード",
    //     operator: "操作者",
    //     operatorPH: "操作者で検索する",
    //     optionOther: "条件追加",
    //     search: "検索",
    //     reset: "リセット",
    //     object: "オブジェクト",
    //     detail: "詳細",
    //     ip: "IPアドレス",
    //     device: "デバイス",
    //     logNull: "関連ログが見つかりませんでした",
    //     logNull2: "検索条件を変更してから再試行してください",
    //     userSearchNot: "この操作者が見つかりませんでした",
    //     userStrSize: "操作者は最大50文字まで入力できます",
    //     fileName: "ファイル",
    //     folderName: "フォルダ",
    //     freeze: "凍結",
    //     team: "テーム",
    //     select: "選択",
    //     item: "",
    //     nullData: "",
    // },
    // logTimingExport:{
    //     delete: "削除",
    //     title: "ログを定時的にエクスポートする",
    //     headInfo: "毎月の初めに、前の暦月のログファイルを定時的にエクスポートします。ログファイルは{year}年間保持します。適時にダウンロードしてください。",
    //     noLog: "ログを生成していません",
    //     openTimingExport: "ログの定時エクスポートが有効になっています",
    //     closeTimingExport: "定時にエクスポートがオフになっています",
    //     comfirmDelete: "選択したログファイルを削除しますか？",
    //     deleteSuccess: "ログを削除しました",
    //     deleteLog: "ログを削除する",
    //     fileName: "ファイル名",
    //     creatTime: "生成時間",
    //     operation: "操作",
    //     download: "ダウンロード",
    //     batchDownload: "一括ダウンロード",
    //     logExportLanguage: "エクスポートするログの言語",
    //     logExportLanguageTips: "言語を切り替えました。次のエクスポートで有効になります",
    // },
    // fileTemp:{
    //     all: "全部",
    //     edit: "編集",
    //     operate: "操作",
    //     topword: "Top",
    //     fileTemptitle: "ファイルテンプレート",
    //     fileTempType: "タイプ",
    //     newFileTempType: "テンプレートタイプを新規作成する",
    //     searchPlaceholder: "テンプレートキーワードを検索する",
    //     typeManage: "タイプ管理",
    //     addTemp: "テンプレートを追加する",
    //     editTemp: " テンプレートを編集する",
    //     defaultType: "デフォルトのタイプ",
    //     tempTypeName: "名称",
    //     DC: "所属のデータセンター",
    //     tempTeam: "通用チーム",
    //     state: "ステータス",
    //     pbliushT: "リリース済み",
    //     pbliushF: "リリースしていない",
    //     publish: "リリース",
    //     repeal: "終了",
    //     deleteTemp: "テンプレートを削除する",
    //     more: "詳細",
    //     top: "最上部に固定する",
    //     cancelTop: "最上部固定を取り消す",
    //     deleteTempTips: "このテンプレートを削除しますか？",
    //     allTeam: "すべてのグループ",
    //     typeName: "タイプ名",
    //     typeNamePlaceholder: "タイプ名を入力してください",
    //     tempTypeMaxNum: "テンプレートタイプの数が上限に達しているため、引き続き作成できません",
    //     tempMaxNum: "テンプレートの数が上限に達しているため、引き続き作成できません",
    //     notNull: "ストレージを入れたり、空にしないでください",
    //     strReg: "/\\:*?\"<>|を入れないでください",
    //     max10: "最大10文字を入力できます",
    //     tempPlaceHolder: "テンプレート名を入力してください",
    //     tempTypePlaceHolder: "テンプレートタイプを選択してください",
    //     teamPlaceHolder: "グループを選択してください",
    //     selectFile: "選択範囲",
    //     amend: "変更",
    //     selectFromPan: "クラウドファイルを選択する",
    //     teamNotNull: "グループが追加されいません",
    //     fileNotNull: "ファイルを選択してください",
    //     sizeReg: "ファイルは50Mを超えないでください",
    //     viriusFile: "このファイルはウィルスを含めているため、利用できません",
    //     tempTypeManage: "テンプレートタイプの管理",
    //     addType: "タイプを追加する",
    //     deleteTitle: "テンプレートタイプを削除する",
    //     deleteTypeTips1: "削除するテンプレートタイプには、テンプレートファイルが含まれています、",
    //     deleteTypeTips2: "テンプレートファイルの処理方法を選択してください",
    //     deleteTypeTips3: "テンプレートタイプのみを削除し、テンプレートファイルをデフォルトタイプに移動する",
    //     allDelete: "共に削除する",
    //     onlyTypeDelete: "タイプのみを削除する",
    //     publishSuccess: "リリースしました",
    //     topSuccess: "最上部に固定しました",
    //     cancelTopSuccess: "最上部固定を終了しました",
    //     repealSuccess: "終了しました",
    //     saveSuccess: "保存しました",
    //     searchNull: "～が見つかりませんでした",
    //     listNull: "ファイルテンプレートのリストは空です",
    // },
    // offline: {
    //     cancel: "終了",
    //     confirm: "確認",
    //     approvalRule:"管理対象者が企業空間から外部チェーンを送信する場合、以下の審査規則を除いて、デフォルトの審査者規則に従って審査を行い、ファイルのリークを防止する。",
    //     linkApprover:"リンク審査員",
    //     confirmTitle: "ヒント",
    //     masterSwitchTitle: "オフラインドキュメント管理",
    //     encryptModeTitle: "暗号鍵モード：",
    //     encryptEntMode: "企業の暗号化と非暗号化",
    //     encryptEntModeTip: "ダウンロードした暗号化ファイルは、企業すべてのメンバーが非暗号化できます",
    //     encryptAccountMode: "アカウントの暗号化と非暗号化",
    //     encryptAccountModeTip: "ダウンロードした暗号化ファイルは、ダウンロード者のみが非暗号化できます",
    //     LinkModeTitle: "暗号化ファイル：",
    //     approvalLinkMode: "リンクの作成は、審査が必要です",
    //     banLinkMode: "リンク禁止",
    //     switchEncryptTip: "暗号モードに切り替えると、ダウンロードしたファイルが非暗号化できなくなります。よろしいですか？",
    //     submit: "提出",
    //     submitSuccess: "提出しました",
    //     hotLine: "カスタマーサービスセンターに連絡してサービスを取得するには、400-898-7968に電話をかけてください。",
    //     offlineTip: "ネットワークに問題が発生しました。もう一度提出してください",
    // },
    // memberControl: {
    //     frozon: "凍結済み",
    //     noTeamSearch: "関連するグループとメンバーがいません",
    //     noUserSearch: "関連するメンバーがいません",
    //     existTip: "同じメンバーまたはグループを繰り返し選択できません",
    //     existToast: "同じメンバーを繰り返して選択できません",
    //     maxLenTip: "追加失敗しました。グループまたはメンバーの数は上限を超えています。",
    //     controlList: "制御されているメンバー ：",
    //     whiteList: "管理ホワイトリスト",
    //     partMember: "一部のグループ/メンバー",
    //     partMemberEnt: "一部のグループ/組織/メンバー",
    //     allMember: "すべてのメンバー",
    //     noControlList: "管理メンバー/グループを追加していません",
    //     noControlListEnt: "管理メンバー/グループ/組織を追加していません",
    //     noWhiteList: "管理ホワイトリストメンバーを追加していません",
    //     selectedSummary: "{teamNum}のグループ、{personNum}のメンバーを制御しています",
    //     selectedSummaryEnt: "{teamNum}のグループ、{orgNum}の組織、{personNum}のメンバーを制御しています",
    //     selectedMemberSummary: "{personNum}のメンバーを選択しています",
    //     searchPlaceholder: "グループ名、ユーザー名またはメールアドレスを検索する",
    //     searchMemberPlaceholder: "ユーザー名またはメールアドレスを検索する",
    //     dialogTitle: "グループ/メンバーを選択する",
    //     dialogVerSelectedMemberSummary: "ホワイトリストに追加されています({personNum})",
    // },
    // controlDictionary: {
    //     noResult: "検索結果がありません",
    //     title: "グループ/メンバーを検索または選択してください",
    //     searchPlaceholder: "ユーザー名、メールアドレスまたはグループ名を検索する",
    //     searchOrgTeam: "ユーザー名、メールアドレスまたは組織名を検索する",
    //     selectedSummary: "{teamNum}のグループ、{personNum}のメンバーを選択しています",
    //     selectedSummaryEnt: "{teamNum}のグループ、{orgNum}の組織、{personNum}のメンバーを選択しています",
    //     noMemberAdded: "グループ/メンバーを検索して追加してください",
    //     noMemberEnt: "グループ/組織/メンバーを選択して参入させてください",
    //     selectAll: "一括選択",
    //     searchSelectedSummary: "{n}の項目を選択しています",
    //     addButton: "追加",
    //     category: "タイプ：",
    //     teamUser: "グループとメンバー",
    //     orgUser: "組織とメンバー",
    // },
    edas: {
        ad: 'AD',
        baseDN: 'Base DN',
        corpId: 'corpid',
        appId: 'appId',
        corpSecret: 'corpSecret',
        ProviderSecret: 'ProviderSecret',
        secret: 'secret',
        appKey: 'appKey',
        appSecret: 'appSecret',
        authentication: '企業認証サービス配置',
        URL:'URL',
        LDAP: 'LDAP',
        ADFS: 'ADFS',
        callBackUrl: 'CallbackURL',
        serviceList: 'サービスリスト',
        all: 'Select all',
        agentId: 'agentId',
        status: 'ステータス',
        operation: '操作',
        cancel: '終了',
        confirm: '確認',
        next: '次へ',
        last: '前へ',
        delete: '削除',
        tips: 'ヒント',
        weaver:'泛微',
        weaverOA:'泛微OA',
        customize: 'カスタム',
        none: 'なし',
        submit: '提出',
        departmentID: '部门标识字段',
        departmentName: '部门名称字段',
        parentDepartment:'父部门',
        agentTips:'当前服务类型无需选择代理名称',
        syncMode: '同步方式',
        syncOrganization: '同步到组织',
        syncTeam: '同步到团队',
        syncUserOnly: '仅同步用户',
        syncOrganizationToolTip: '将对接系统的组织和人员同步到网盘组织中',
        syncTeamToolTip: '将对接系统的人员同步到组织下，将对接系统的组织结构同步到团队中',
        syncUserOnlyToolTip: '仅将对接系统的人员同步到组织根节点下，不同步组织',
        hours: '時',
        mins: '分',
        more: 'より',
        back: '戻る ',
        detail: '详细',
        object: '対象',
        action: '操作',
        remarks: '備考',
        success: '成功',
        team: 'グループ',
        move: '移动',
        frozen: '凍結',
        netError: "ネットワーク接続エラーが発生しました。しばらくしてから再試行してください",
        setFilter: '设置过滤条件',
        import: 'インポート',
        modify: '変更',
        upload: 'アップロード',
        edit: '編集',
        condition: '个条件',
        loadMore: 'さらに読み込む',
        items: '項',
        organization:'組織',
        unSyncOrganization:'未同步组织',
        urlTip:'请输入带http://或https://的URL',
        title: "企業アカウントの認証",
        subHeader: "オープンプラットフォームを企業ドメインとドッキングして、企業の既存のユーザーと組織構造を迅速に導入して同期させることができます。",
        importServerConfig: "組織インポートサービスの設定",
        sync: "組織インポートサービスの設定",
        authServerConfig: "ログイン認証サービスの設定",
        auth: "ログイン認証サービスの設定",
        agentName: "プロキシ名",
        serviceName: "サービス名",
        serial: "シリアル番号",
        ctime: "作成時間",
        addAgentServer: "プロキシサービスを追加する",
        addServerConfig: "サービス設定を追加する",
        editServerConfig: "サービス設定を編集する",
        autoSyncTime: "自動同期時間",
        lastSyncTime: "前回の同期時間",
        newAgentSrver: "プロキシサービスを新規作成する",
        unbound: "紐づけを解除する",
        unbind: "紐づけていません",
        normal: "正常",
        disconnect: "接続切れ",
        hasAddAgentServer: "プロキシサービスを追加しました",
        unboundTips: "紐づけを解除すると、このプロキシサービスが利用できなくなります。引き続き解除しますか？",
        confirmUnbound: "引き続き解除する",
        deleteTips: "削除すると、このサービスの紐づけが解除され、関連パラメーターも消去されます。よろしいですか？",
        serviceType: "サービスタイプ",
        corpWX: "企業WeChat",
        dingding: "DingTalk",
        connectConfig: "接続設定",
        serviceAddress: "サーバーアドレス",
        serviceManageAccount: "サーバーの管理アカウント",
        password: "パスワード",
        port: "ポート",
        fieldMapping: "フィールドマッピング",
        userID: "ユーザーマークフィールド",
        userNameField: "ユーザー名フィールド",
        emailField: "ユーザーメールアドレスフィールド",
        mobileField: "ユーザー携帯番号フィールド",
        login: "ユーザーログインフィールド",
        teamID: "グループマークフィールド",
        teamName: "グループ名フィールド",
        allowMailImportToBeEmpty: "メールアドレスのインポートは、空であっても構いません。",
        mailImportToolTip: "チェックを外した場合、空にしないでください。メールアドレスが空であるユーザーをインポートしません。",
        customField: "カスタマイズフィールド",
        lenovoboxField: "クラウドストレージフィールド",
        importField: "フィールドをインポートする",
        addField: "フィールドを追加する",
        syncConfig: "設定を同期する",
        defaultImportMode: "デフォルトのインポート方法",
        allImport: "すべてインポートする",
        allNoImport: "どれもインポートしない",
        syncTime: "執行時間を同期する",
        accordingDay: "日で",
        accordingHour: "時間で",
        hour: "時間",
        min: "分",
        adfsCertificate: "adfs証明書 (jks形式)",
        certificatePassword: "証明書のパスワード",
        adfsAddress: "ADFSアドレス",
        everyday: "毎日",
        every: "ごと",
        syncOperation: "今すぐ同期する",
        log: "ログ",
        setServiceConfig: "サービス設定を設定する",
        setFiltrationConditions: "フィルタリング条件を設定する",
        deleteSuccess: "削除しました",
        syncCompleteTime: "完成時間を同期する",
        syncSuccess: "同期しました",
        syncFail: "同期できませんでした",
        unSync: "同期されていません",
        unSyncToolTip: "ブラックリストにフィルタリングされ、同期されていないデータ",
        export: "エクスポート",
        syncDetail: "同期の詳細情報",
        detailSyncTime: "同期時間",
        allSyncResult: "すべての同期結果",
        failReasons: "失敗の原因",
        fail: "失敗",
        user: "ユーザー",
        created: "作成",
        update: "更新",
        unfrozen: "解凍",
        filter: "フィルタリング済み",
        unSyncUser: "同期されていないユーザー",
        unSyncTeam: "同期されていないグループ",
        importServiceConfigCuccess: "インポートサービスの設定を追加しました！",
        filterInquiry: "インポートのフィルタリング条件を今すぐ設定しますか？",
        noSettings: "今は設定しない",
        goSettings: "設定する",
        addFilter: "条件を追加する",
        addFilterCondition: "フィルタリング条件を追加する",
        modifyFilterCondition: "フィルタリング条件を変更する",
        batchImport: "一括インポート",
        userEmail: "ユーザーメールアドレス",
        userPhone: "ユーザー携帯番号",
        userName: "ユーザー名",
        teamUser: "グループ名",
        filteringContent: "フィルタリング対象",
        allConditionalType: "すべての条件タイプ",
        allFilterMode: "すべてのフィルタリング方法",
        noImport: "インポートしない",
        conditionalType: "条件タイプ",
        filterMode: "フィルタリング方法",
        importModeDesc: "インポート方法は、サービス設定で変更できます",
        addedNumber: "追加済み",
        addedText: "の条件",
        first: "ステップ1",
        downloadTemp: "テンプレートをダウンロードします",
        downloadTempDesc: "xlsまたはxlsxファイルとなります",
        second: "ステップ2",
        editedUpload: "内容を編集してからアップロードします",
        uploadCertificate: "証明書をアップロードする",
        deleteItem: "選択した項目を削除する",
        selectedText: "選択した項目を削除しますか？",
        importLogTitle: "設定したログリストをインポートする",
        mostNumber: "最大は10のフィールドに関連する",
        enterLenovoboxField: "クラウドストレージフィールドを入力してください",
        enterImportField: "インポートするフィールドを入力してください",
        agentRelease: "プロキシの紐づけが解除されました",
        noServiceConfig: "サービス設定を追加していません",
        noAgentService: "プロキシサービスを追加していません",
        syncConfigDesc: "提出すると、フィルタリング条件を追加し、一部のユーザーをフィルタリングできます。",
        noDetailResulr: "関連する検索結果がありません",
        filterTitleTip: "デフォルトでは、すべてのデータをインポートするようになっています。どれもインポートしないように設定したり、条件を追加して一部のデータをインポートしたりできます。",
        importAcount: "合計はをインポートしました",
        copy: "コピー",
        copySuccess: "コピーしました",
        copyFail: "コピーできませんでした",
        serviceNamePlaceholder: "サービス設定名を入力してください。最大は50特殊文字を入力できます。",
        serviceAddressPlaceholder: "例えば：120.22.100.11",
        manageAccountPlaceholder: "接続するサーバー管理アカウントを入力してください",
        enterPasswordPlaceholder: "パスワードを空にしないでください",
        enterSearchValue: "検索内容を入力してください",
        selectFilterType: "フィルタリング条件のタイプを入力してください",
        enterEmail: "ユーザーメールアドレスを入力してください",
        enterUserPhone: "ユーザー携帯番号を入力してください",
        enterUserName: "ユーザー名を入力してください",
        enterTeamName: "グループ名を入力してください",
        noSearchResult: "グループ名を入力してください別のキーワードで再試行してください",
        beyondLimit: "10000件の上限を超えています",
        configSuccess: "設定しました",
        deleteConfirm: "削除しますか？",
        item: "個",
        noFilterSearchResult: "関連する検索結果がありません。別のキーワードで再試行してください",
        character: "サービス設定名を入力してください。最大は50特殊文字を入力できます。",
        noErrorSpecialCharacters: "以下の特殊文字は入力できません",
        isSyncing: "同期しています",
        jksFile: "jks形式",
        uploadJksFile: "jks形式のファイルをアップロードしてください",
        inputCertificatePassword: "証明書のパスワードを空にしないでください",
        address: "アドレスを入力してください",
        modifySuuccess: "変更しました",
        agentPlaceholder: "プロキシサービス名を入力してください。最大は50特殊文字を入力できます",
        inputTeamOrUser: "ユーザー名/グループ名を入力して検索する",
        addFilterSuccess: "フィルタリング条件を追加しました",
        modifyFilterSuccess: "フィルタリング条件を変更しました",
        errorEmail: "メールアドレスの形式が間違っています",
        errorMobile: "携帯番号の形式が間違っています",
        bindingServerConfig: "第三者紐づけサービスの設定",
        matchingRule: "マッチングルール",
        mobile: "携帯番号",
        email: "メールアドレス",
        syncResult: "同期結果",
        newBinding: "新規紐づけ",
        failBinding: "紐づけできませんでした",
        account: "アカウント",
        bindingLogTitle: "設定したログリストを紐づけする",
        inputAccount: "アカウントを入力してください",
        signCongit: "スキャンコード登録サービスの設定",
        SSO: "ワンポイント登録（SSO）サービス配置",
        sso: "ワンポイント登録（SSO）サービス配置",
        searchSuccess: 'クエリが成功しました',
        allSuccess:'Success',
        startSuccess:'Success',
        closeSuccess:'Success',
        uploadSuccess:'Success',
        scanName: 'ログイン名',
        boxUrl: 'ディスクアクセスアドレス',
        copyUrl: 'アドレスをコピー',
        identification: '識別情報を一致させる',
        appKeySecret: 'appKeySecret',
        ssoWarning: 'プロキシサービスを利用していますので、システムはプロキシサーバのアドレスを取得できませんので、ネットワークディスクを使ってアドレスにアクセスする時は、手動でプロキシサービスのIPまたはアドレスをxxxの場所に記入してください。https://lenovows.com/user/manager',
        agentWarning: 'プロキシサービスは最大1つの構成を追加します。',
        importWarning: '組織導入サービスは最大1つの設定を追加します。',
        authWarning: '登録認証サービスは最大1つの設定を追加します。',
        schema: 'schema',
        userStatus: 'ユーザの状態',
        probation:'仮採用',
        formal:'正式',
        temporary:'臨時',
        probationExtension:'試用延期',
        dismissal:'結納を解く',
        resignation:'職を離れる',
        retirement:'定年退職',
        invalid:'無効です。正式ユーザーのみ同期します。',
        importSealTeam:'保存チームを導入する',
        yes:'はい、',
        no:'いいえ、',
        relationship: '関係',
        appIdMobile: 'appIdMobile',
        appSecretMobile: 'appSecretMobile',
        applicationVoucher:'応用証明書',
        applicationVoucherTitle:'ピンを接続するアプリケーション証明書を構成して、ピンユーザの基礎情報を取得する',
        scanLogin:'スキャンコード登録',
        qrcode:'スキャンコード登録',
        scanLoginTitle:'は、釘付けコード登録アプリケーションのライセンス情報を設定して、釘付けコードでネットディスクにログインすることを実現します',
        mobileAuthorizedLogin:'モバイル端末ライセンス登録',
        mobileAuthorizedLoginTitle:'はピンをセットする「モバイルアプリケーションアクセス-共有」のライセンス情報を、モバイル端末がピンで登録できるようにすることができます',
        kingdee: 'Kingdee',
        createSuperiorTeam: '親チームを自動的に作成する',
        createSuperiorOrg: '親組織を自動的に作成する',
        autCreateSuperiorTeam: '追加されたフィルター条件がチームに同期されると、優れたチームが自動的に作成されます',
        autCreateSuperiorOrg: '追加されたフィルター条件が組織に同期されると、親組織が自動的に作成されます',
        ...store.getters['ja']
    },
    app: {
        'thirdApp': '第三者アプリケーション',
        'appManager': 'アプリケーション管理',
        'createApp': 'アプリケーションを作成',
        'editApp': '適用を変更',
        'appName': '名前を適用',
        'appDesc': 'アプリケーションの説明',
        'appIcon': 'アイコンを使う',
        'ipManage': 'IP管理',
        'addIp': 'IPアクセスを追加',
        'appNameTip': 'アプリケーション名を50文字以内に入力してください',
        'addIpDesc': 'このアプリケーションにアクセスするIPを記入してください。複数のIPは「、」で区切ってください。IPセグメントを記入することをサポートします。IP開始アドレスと終了アドレスは「-」で区切られています。',
        'rateLimit': 'インターフェース周波数制限',
        'setRateLimit': 'インターフェース周波数の設定',
        'rateLimitDesc': 'アプリケーションが頻繁に起動されてサーバー負荷が異常になることを防止するために、デフォルトの場合、各サービス端末インターフェースの呼び出しには周波数制限があります。この制限を超えた場合、対応インターフェースを呼び出すと、対応するエラーコードが返されます。',
        'rateLimitNumber': '上限を示す数字が必要です',
        'rateLimitUnit': '回/分',
        'appVoucher': '応用証明書',
        'baseInfo': '基本情報',
        'appAvatar': 'アイコンを使う',
        'editInfo': '情報を編集',
        'backUp': 'アプリケーション管理に戻る',
        'deleteApp': 'アプリケーションを削除',
        'voucher': '証憑と基礎情報',
        'authManage': '権限管理',
        'createSuccess': '作成成功',
        'createError': '作成に失敗しました',
        'modifySuccess': '修正成功',
        'modifyError': '変更に失敗しました',
        'delSuccess': '削除に成功しました',
        'delError': '削除に失敗しました',
        'modifyAuthSuccess': 'バッチ設定成功',
        'modifyAuthError': '一括設定に失敗しました',
        'deleteConfirm': '削除の確認',
        'appNumLimit': 'アプリケーションの数が上限に達しました，作成を続けられませんでした',
        'ipFormatError': 'IP範囲フォーマットエラー',
        'deleteConfirmTitle': '本当にこのアプリケーションを削除しますか？',
        'deleteDesc': 'アプリケーション情報を確認してください。削除後は回復できません。証明書は無効になります',
        'imgFormatLimit': 'アップロードはJPG/PNG形式のみ対応しています',
        'imgBulkLimit': '画像は120 KB以下でなければなりません',
        'imgSizeLimit': '画像は240*240 px以上でなければなりません',
        'imgTip': 'JPG/PNG形式、240*240 px以上、1:1、120 kb以内の角なしアイコンをアップロードしてください',
        'appNameRequired': '名前の適用は空ではありません',
        'appNameIsExit': 'アプリケーション名が使用されています',
        'ipRequired': 'アクセスIPを追加してください'
    },
    // addUser: {
    //     title: "メンバーを追加する",
    //     searchLable: "メンバーを検索または選択してください",
    //     searchInput: "搜索用户名、邮箱或组织名",
    //     allSelected: "合計{0}人のメンバーがあります",
    //     selected: "{0}人のメンバーを選択しています",
    //     selectJoin: "メンバーを選択して参入させてください",
    //     continue: "既存のメンバーを追加すると、ユーザーの組織関係が変わります。よろしいですか？",
    // },
    // batchImport: {
    //     bulk: "ユーザーを一括インポートする",
    //     title: "ユーザーを一括追加する",
    //     downloadTemp: "ステップ1：テンプレートファイルをダウンロードする",
    //     editTemp: "ステップ2：テンプレートファイルを編集する",
    //     uploadTemp: "ステップ3：編集したファイルをアップロードする",
    //     downloadBtn: "download",
    //     fileType:"xls或xlsx文件",
    //     progress: "テンプレート中のユーザーをインポートしています。しばらくお待ちください...",
    //     total: "合計{0}人のユーザーがあります",
    //     upSuccess: "{0}人のユーザーをインポートしました",
    //     upFailed: "{0}のアカウントをインポートできませんでした",
    //     user: "ユーザー名",
    //     mail: "メールボックス",
    //     phone: "携帯番号",
    //     pwd:"パスワード",
    //     org: "組織",
    //     state:"ステータス",
    //     noFile: "ファイルをアップロードしていません",
    //     errorType: "許可されていないファイルタイプであるため、{0}をアップロードできません",
    //     emptyFile: "ファイルが空です",
    //     upSuccessTip: "インポートしました",
    //     more: "ファイルが500Mを超えているため、",
    //     client: "クライアントを使ってください",
    //     upload:"上传",
    //     flashTip: "この機能を利用するには、Flashプラグインをインストールする必要があります。",
    //     here: "ここをクリックして",
    //     install: "インストールします",
    //     force: "インポートされたユーザーにデフォルトパスワードの変更を強要します",
    // },
    // createUser: {
    //     title: "ユーザーを追加する",
    //     org: "所属組織：",
    //     mail: "メールボックス",
    //     mailInput:"ログイン用のメールアドレスを入力してください",
    //     name: "名称：",
    //     nameInput:"ログイン用のメールアドレスを入力してください",
    //     phone: "携帯番号：",
    //     date: "有効期限：",
    //     setDate: "アカウントの有効期限を追加する",
    //     seletDate: "日付を選択する",
    //     data: "データ中心",
    //     space: "個人スペース",
    //     spaceInput: "ストレージ容量を入力してください",
    //     spaceTips: "ストレージの総容量以内にしてください",
    //     active: "メールで有効化リンクを送信し、ユーザーにパスワードを設定してもらう",
    //     set: "管理者にパスワードを設定してもらう",
    //     pwdTips: "パスワードは6~32文字で、少なくとも2種類の特殊文字の組み合わせを入力してください。",
    //     forbidPwd: "アカウントによるパスワード変更を禁止する",
    //     allowPwd: "パスワード変更を許可する",
    //     firstLoginPwd: "初めてログインする際に、パスワードを変更する",
    //     success: "ユーザーを作成しました",
    //     phonePlaceholder: "携帯番号を入力してください",
    //     area: "国/地域を検索する",
    //     areaNull: "関連国家と地区が見つかりませんでした",
    //     seletDateTips: "この期限が満了すれば、このアカウントはログインできなくなります",
    // },
    // userSet: {
    //     title: "ユーザー設定",
    //     userType: "タイプ",
    //     sended: "送信済み",
    //     active: "有効化済み",
    //     noactive: "有効化されていない",
    //     sendEmail: "招待を有効化する",
    //     pwd: "ログイン用のパスワード：",
    //     setPwd: "ログイン用のパスワードを変更する",
    //     inputPwd:"パスワードを空にしないでください",
    //     team: "所属グループ：",
    //     invitation: "招待を送信しました",
    //     invitationSuccess: "1時間内では、繰り返して招待を送信できません",
    //     success: "ユーザー設定しました",
    //     noData: "このユーザーの個人ストレージにデータがあるため、データセンターを切り替えることができません。",
    //     confirmData: "変更するには、データを移動してから再試行してください",
    //     isData: "データセンターを切り替えますか？",
    //     yesData: "データセンターを切り替えると、削除したデータは復元できません",
    //     localUser: "ロカール認証ユーザー",
    //     entUser: "企業認証ユーザー",
    //     thirdUser: "第三者認証ユーザー",
    //     pwdTip:"第三方应用同步的用户不支持设置密码",
    // },
    // adminRole:{
    //     title: "管理者ロール",
    // },
    // orgManage:{
    //     title: "組織管理",
    //     createUser: "ユーザーを新規作成する",
    //     addLocalUser: "既存のユーザーを追加する",
    //     batchUser:"ユーザーを一括インポートする",
    //     forze:"凍結",
    //     unforze: "解凍",
    //     batchSet: "一括設定",
    //     search: "ユーザー名、メールアドレスを入力して検索する",
    //     userBatchSet: "アカウントの一括設定",
    //     spaceErr:'ストレージ容量は正の整数を入力してください',
    //     deleteUserConfirm: "選択したユーザーを削除しますか？",
    //     deleteUserConfirm2: "このユーザーの個人ストレージには、他人と共有しているフォルダがありません",
    //     deleteUserConfirm3: "ユーザーを削除すると、その個人ストレージのデータを削除し、すべての権限を終了します",
    //     confirm: "確認",
    //     confirmDelete: "削除する",
    //     spaceNullErr:"空间大小不能为空",
    //     addOrg: "組織を追加する",
    //     searchOrg: "組織名を検索する",
    //     dissOrg: "組織を解散する",
    //     deleteOrg: "組織を削除する",
    //     renameOrg: "組織名を変更する",
    //     level: "所属レベル",
    //     orgName: "組織名",
    //     orgNamePlaceholder: "組織名を入力してください。最大128特殊文字を入力できます。",
    //     dissOrgMsg: "この組織とその子組織を解散します",
    //     dissOrgMsg2: "この組織のメンバーと子組織は、自動的に1レベル上の組織に帰属します",
    //     deleteOrgMsg: "組織を削除しますか？",
    //     deleteOrgMsg2: "子組織とメンバーは、同時に削除されます",
    //     searchOrgNull: "関連組織が見つかりませんでした",
    //     selected: "選択しています",
    //     members: "のメンバー",
    //     username:"ユーザー名",
    //     email:"メールアドレス",
    //     mobile:"携帯番号",
    //     dcId:"データセンター",
    //     quota:"個人スペース",
    //     ctime:"作成時間",
    //     teamName:"組織",
    //     etime: "期限満了時間",
    //     login_time:"最近登录时间",
    //     exporting:"导出中",
    //     cancel:"終了",
    //     all:"全部",
    //     inDay: "日間以内",
    //     userState: "アカウントステータス",
    //     opearte:"操作",
    //     operationSet:"ユーザー設定",
    //     operationMore:"詳細",
    //     modifyEmail: "アカウントのメールアドレスを変更する",
    //     deleteUser: "ユーザーを削除する",
    //     orgNullUser: "この組織にはメンバーがいません",
    //     choiceNullUser: "関連ユーザーがありません",
    //     loginEmial:"メールボックス",
    //     normal:"正常",
    //     frozen:"凍結済み",
    //     unfrozen: "凍結されていません",
    //     activeted:"有効化済み",
    //     unactiveted:"有効化されていない",
    //     emialChange: "メールアドレスを次に変更しました。",
    //     deleteSuccess:"削除しました",
    //     errorTextMax: "入力できる特殊文字の上限に達しています。",
    //     forzeConfirm: "アカウントを凍結すると、そのアカウントでクラウドストレージにログインできなくなります。その個人ストレージにあるデータとグループ権限は保留されます。このアカウントを凍結しますか？",
    //     unforzeConfirm: "選択したユーザーを解凍しますか？",
    //     forzeSuccess: "凍結を解除しました",
    //     personNum: "人",
    //     searchRolePlacehodler: "検索キーワードを入力する",
    //     orgDeleteSuccess: "組織を削除しました",
    //     export:"エクスポート",
    //     customDialogHeader:"自定义列表项",
    //     enterpriseCertifiedUsers:"企业认证用户",
    //     thirdPartyCertifiedUsers:"第三方认证用户",
    //     exportOutTime:"导出超时，请重试。",
    //     save:'確認',
    // },
    // adminList: {
    //     title: "管理者設定",
    //     singleDelete: "この管理者を削除しますか？",
    //     multipleDelete: "選択した管理者を削除しますか？",
    //     addAdmin: "管理者を追加する",
    //     editAdmin: "管理者を編集する",
    //     adminAuth: "権限を管理する",
    //     authScope: "制御範囲",
    //     adminEmpty: "管理者がありません",
    //     userName: "名称：",
    //     auth: "管理権限：",
    //     scope: "制御範囲：",
    //     posTeam: "グループ指定",
    //     allTeam:"All teams",
    //     posFile: "一部のグループファイル",
    //     allFile: "すべてのファイル",
    //     searchTeam: "グループ名を検索する",
    //     noSearchTeam: "関連グループが見つかりませんでした",
    //     control: "{0}のグループを管理しています",
    //     addControl: "制御を追加する",
    //     nullControl: "管理グループを追加していません",
    //     selectUser: "1人のユーザーを選択してください",
    //     noSelectAuth: "権限を選択していません",
    //     noSelectTeam: "管理グループを選択していません",
    //     noAddTeam: "管理グループが追加されていません",
    //     addAdminOk: "管理者を追加しました",
    //     chooseSame: "同じはグループを繰り返して選択できません",
    //     beyondlimit: "管理グループの数が上限を超えているため、追加できませんでした",
    //     selectAuthTip: "クリックして権限を選択してください",
    //     repeatAuth: "同じ権限を繰り返して授与できません",
    //     inputUser: "ユーザー名またはメールアドレスを入力してください",
    //     nullUser: "関連ユーザー名が見つかりませんでした",
    //     selectedTeam: "{0のグループを選択しています",
    //     selectJoin: "グループを選択して参入させてください",
    //     searchNull: "関連ユーザーが見つかりませんでした",
    //     partFail: "一部の削除が失敗しました。リストで確認してから再試行してください",
    //     controlNum: "合計{0}の管理グループがあります",
    //     controlTeamList: "グループ管理リスト",
    //     controlledTeams: "管理している{0}のグループ：",
    // },
    // transferAuth: {
    //     title: "権限を譲渡する",
    //     searchTitle: "クラウドストレージのメンバー",
    //     folderAuth: "フォルダの共有メンバー",
    //     noAuth: "フォルダの共有メンバーがいません",
    //     folders: "の{0}の共有フォルダ",
    //     userTooltip: "一部のユーザーは、他人と共有しているフォルダを持っています。下記の操作ができます。",
    //     userTooltip2: "1.完全に削除し、その個人フォルダと共有フォルダのデータを消去します",
    //     userTooltip3: "2.その共有フォルダをクラウドストレージのほかのユーザーに譲渡します",
    //     userTooltip4: "{0}が他人と共有しているフォルダを持っています",
    //     transfer: "譲渡して削除する",
    //     tips: "選択したユーザー{0}は、他人と共有しているフォルダを持っています。",
    //     tipsOrg: "組織には、他人と共有しているフォルダが{0}あります。",
    //     tips2: 'ユーザーを削除すると、その個人ストレージのデータを削除し、すべての権限を終了します',
    //     tips3: "下記の操作ができます：",
    //     tips4: "ユーザーとその共有フォルダを同時に削除します",
    //     tips5: "ユーザーを削除し、共有フォルダをほかのユーザーに譲渡します",
    //     tips6: "譲渡する共有フォルダを選択してください。選択されていない共有フォルダは、完全に削除されます。",
    //     selectUser: "{0}人のメンバーを選択しています",
    //     deleted: "削除しました",
    //     transferDeleted: "譲渡して削除しました",
    //     delete: "完全削除",
    //     searchResult: "検索結果：",
    //     folderUser:'フォルダの共有メンバー',
    //     userNull: "関連メンバーが見つかりませんでした",
    //     userSuccessTip: "ユーザー権限を譲渡して削除しました",
    //     userAllSuccess: "すべての操作が成功しました",
    //     userUserSuccess: "ユーザーを削除しました",
    //     userOtherSuccess: "一部の操作が有効です。ています",
    // },
    // synctask:{
    //     title: "タスクを同期する",
    //     tips: "指定しているフォルダのファイルをほかのデータセンターに同期し、データを保存します",
    //     openservice: "カスタマーサービスセンターに連絡してサービスを取得するには、400-898-7968に電話をかけてください。",
    //     choosefile: "フォルダを選択してください",
    //     addtasktips: "最大{0}の同期タスクを追加できます",
    //     addtasktipshover: "1つの同期モジュールを設置するごとに、{0}の同期タスクを追加できます",
    //     addtask: "同期タスクを追加する",
    //     taskFolder: "フォルダを同期する",
    //     dataCenter: "所属のデータセンター",
    //     taskTo: "に同期する",
    //     chooseDataCenter: "データセンターを選択してください",
    //     syncTiming: "定時同期",
    //     chooseTime: "時点を選択してください",
    //     folder:'フォルダ',
    //     syncDataCenter: "データセンターを同期する",
    //     createTime:'作成時間',
    //     creater: "作成者",
    //     taskState: "タスクステータス",
    //     operate:'操作',
    //     notTask: "同期タスクがありません",
    //     editTask: "同期タスクを変更する",
    //     syncFolder:'フォルダを同期する',
    //     deleteTask: "同期タスクを削除する",
    //     confimTask: "この同期タスクを削除しますか？",
    //     taskLog: "タスクログ",
    //     change: "変更",
    //     exception: "異常",
    //     normal:'正常',
    //     taskSuccess: "同期タスクを作成しました",
    //     taskChangeSuccess:'変更しました',
    //     notSameTime: "同じ時間を選択できません",
    //     noModules: "同期モジュールを検出できませんでした。同期モジュールを構築してからタスクを追加してください",
    // },
    // 安全连接翻译开始
    // "安全链接": "セキュリティリンク",
    // "链接安全管控": "セキュリティ管理",
    // "管控目录的文件": "管理目録ファイル",
    // "如果允许管控目录内的文件移动或复制，会导致文件不受此规则管控": "管理ディレクトリのファイルを移動またはコピーすると、このファイルはこのルールに制御されなくなります",
    // "禁止移动": "移動禁止",
    // "禁止复制": "コピー禁止",
    // "链接最长有效期": "最長有効期限",
    // "目录所在路径": "目録所属パス",
    // "禁止重命名": "名称変更を禁止する",
    // "联系客服开通服务，请拨打 400-898-7968": "カスタマーサービスセンターに連絡してサービスを取得するには、400-898-7968に電話をかけてください",
    // "如果管控目录所在路径被重命名，会导致此管控规则失效": "管理ディレクトリの所属パスの名称が変更された場合、この管理ルールが無効になります",
    // "目录链接管控规则": "目録リンク管理規則",
    // "规则说明": "ルールの説明",
    // "添加管控规则": "管理ルール追加",
    // '管控白名单': 'ホワイトリスト管理',
    // '开启后仅能通过windows客户端下载网盘内文件，下载的文件将会加密，有效提升数据安全性': 'オープン後はwindowsクライアントだけでクラウドストレージ内のファイルをダウンロードできます。ダウンロードしたファイルは暗号化され、データの安全性を向上させます。',
    // '您的企业暂未开通此服务，如需开通功能请拨打客服电话：400-898-7968':'貴社はまだこのサービスを開通していません。サービスを開通するなら、カスタマーサービスの電話をかけてください。',
    // '您的企业暂未开通此服务':'貴社はまだこのサービスを開通していません',
    // '如需开通功能请拨打客服电话：400-898-7968':'サービスを開通するなら、カスタマーサービスの電話をかけてください。',
    // '天': "日",
    // '年': "年",
    // //sp2-start
    // "禁止上传": "アップロードを禁止する",
    // "禁止下载": "ダウンロードを禁止する",
    // "禁止预览": "プレビューを禁止する",
    // "仅内部成员可用": "内部メンバーのみが使用できます",
    // "最长有效期": "最長有効期限",
    // "请输入正整数": "正の整数を入力してください",
    // "生成链接必须添加密码": "リンクの作成は、パスワードを空にしないでください",
    // "最多阅读次数": "最大閲覧回数",
    // "最长阅读时长": "最長閲覧時間",
    // "文档只读": "読込み専用ドキュメント",
    // "禁止打印": "プリントを禁止する",
    // "失效后删除": "失効したら削除する",
    // "添加水印": "ウォーターマークを追加する",
    // "请输入水印": "ウォーターマークを入力してください",
    // '取消': '終了',
    // '确定': '確認' ,
    // '提交': '提出',
    // "暂无搜索结果": "検索結果がありません",
    // "子团队继承规则": "サブグループの継承ルール",
    // "最多可下载次数": "ダウンロードできる最大回数",
    // "还未配置规则": "ルールを設置していません",
    // "您可以添加规则来限制网盘成员使用链接的设置项": "ルールを追加して、クラウドストレージメンバーによるリンク操作の使用を制限できます",
    // "没有相应的目录": "関連するディレクトリがありません",
    // "白名单": "ホワイトリスト",
    // "管控目录": "管理ディレクトリ",
    // "管控用户": "管理ユーザー",
    // '创建者': '作成者',
    // '创建时间': '作成時間',
    // '操作': '操作',
    // '设置': '"設定",',
    // '删除': '削除',
    // "返回链接管控设置": "リンク制御設定に戻る",
    // "目录链接规则设置": "ディレクトリリンクルールの設定",
    // "点击或搜索目录名": "ディレクトリ名をクリックまたは検索する",
    // '企业空间': '企业空间',
    // '链接审批规则':'リンク審査ルール',
    // '添加审批规则':'審査ルール追加',
    // '还没有添加链接审批规则':'リンク審査ルールはまだ追加していません',
    // "设置普通链接管控": "通常リンクの管理を設定する",
    // "设置安全链接管控": "セキュリティリンクの管理を設定する",
    // "次": "回",
    // "小时": "時間",
    // '所有用户': 'すべてのユーザー',
    // '删除成功': '削除しました',
    // "删除失败": "削除できませんでした",
    // "管控规则已达上限": "管理ルールが上限を達しています",
    // '提交成功': '提交成功',
    // '提交失败': "提出できませんでした",
    // '网络问题，请重新尝试提交': 'ネットワークに問題が発生しました。もう一度提出してください',
    // "请输入": "を入力してください",
    // "水印": "ウォーターマーク",
    // "请选择要管控的目录": "制御するディレクトリを選択してください",
    // "请选择受管控的用户": "制御するユーザーを選択してください",
    // "请至少允许一项": "少なくとも1つを選択してください",
    // "始终链接到文件最新版本": "いつでもファイルの最新バージョンにリンクします",
    // '提示': '提示',
    // "链接安全管控规则不会影响历史创建的安全链接，请检查历史链接是否存在安全风险！是否确认提交？": "リンクのセキュリティ管理ルールが過去に作成したセキュリティリンクに影響を与えないため、過去のリンクにセキュリティリスクがないことを確認してください！提出しますか？",
    // "您确认要删除选中的管控规则吗？": "選択した管理ルールを削除しますか？",
    // "全局规则获取失败": "全体ルールを取得できませんでした",
    // "输入用户名或邮箱，添加白名单用户": "ホワイトリストユーザーを入力して、追加します。",
    // "白名单仅可以添加用户，被添加到白名单的用户不受到管控规则的影响。": "ホワイトリストに追加できるのはユーザーだけです。ホワイトリストに追加されているユーザーは、管理ルールに管理されません。",
    // //sp2-end
    // 安全连接翻译结束
    //hover优化start
    // '路径：': "パス：",
    // '邮箱：': "メールアドレス：",
    //hover优化end
};





// WEBPACK FOOTER //
// ./static/js/language/ja.js